export default "ALTER TABLE `chat_settings` DROP COLUMN `repetition_penalty`;"